import {useCallback, useContext, useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {Box} from '~/common/fabric/Card/components/Box/Box';
import {Colors} from '~/common/fabric/Card/components/Colors/Colors';
import {desktopColors, mobileColors} from '~/common/fabric/CreateDesign/constants';
import {ColorUnit} from '~/common/fabric/Card/components/ColorUnit/ColorUnit';
import {EyeDropper} from '~/common/fabric/Card/components/EyeDropper/EyeDropper';
import {selectEditorDisabled} from '~/CreateFabricGreetingCard/reducers/fabricDesign/selectors';
import {useMatchQuery} from '~library/hooks/useMatchQuery';
import {FabricContext} from '~/common/fabric/context/FabricContext';
import {largishAndUp} from '~libSass/base/_exports.sass';

import './ColorPicker.sass';

export const ColorPicker = () => {
  const [color, setColor] = useState('#000');
  const {canvas} = useContext(FabricContext);
  const editorDisabled = useSelector(selectEditorDisabled);
  const {matches: isDesktop} = useMatchQuery(`(min-width: ${largishAndUp})`);
  const isMobile = !isDesktop;
  const colors = isMobile ? mobileColors : desktopColors;

  useEffect(() => {
    setColor(canvas?.getActiveObjects()?.[0]?.fill);
    canvas?.on('object:reset', () => setColor(canvas?.getActiveObjects()?.[0]?.fill));
  }, [canvas]);

  const onChangeHandler = useCallback(
    (color) => {
      const activeObjects = canvas.getActiveObjects();
      setColor(color);
      activeObjects.forEach((obj) => obj.set('fill', color));
      canvas.requestRenderAll();
      canvas.fire('object:modified');
    },
    [canvas]
  );

  const onInputColorChange = useCallback(({target: {value}}) => onChangeHandler(value), []);

  return (
    <div className="color_picker">
      <div className="info">
        <Box padding={8} borderRadius={8} className="info__box">
          <ColorUnit
            color={editorDisabled ? '#6B5A3A' : color}
            key={color}
            dataQaId={`step1-textcolor-select-${color}`}
          />
          <input
            type="text"
            value={editorDisabled || !color ? '#' : color}
            onChange={onInputColorChange}
            disabled={editorDisabled}
            data-qa-id="step1-textcolor-input"
          />
        </Box>

        <EyeDropper color={color} onChange={onChangeHandler} />
      </div>
      <Colors
        colors={colors}
        onClick={onChangeHandler}
        highlight={false}
        disabled={editorDisabled}
      />
    </div>
  );
};
